export default __webpack_public_path__ + "static/media/Product-3.c580b455.jpg";